import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './external.intl.json';

export const useExternalIntl = () => useIntlModule(messages);
